import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

// Import helpers
import useInfoContext from 'components/views/vod/views/ProductDetails/Layout/Info/context/useInfoContext';

const usePacketsButton = ({ uuid, subtype }) => {
	const ref = useRef();
	const { t } = useTranslation();
	const { setVodOnlyInPackets } = useInfoContext();

	const handleClick = () => setVodOnlyInPackets(uuid, subtype);
	const buttonText = t(`vod_buttons_check_availability_${subtype}`);

	return {
		ref,
		handleClick,
		buttonText
	};
};

export default usePacketsButton;
